const p = function(e, n) {
    let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _r_leading, _r_trailing;
    const a = n, c = (_r_leading = r.leading) !== null && _r_leading !== void 0 ? _r_leading : !1, g = (_r_trailing = r.trailing) !== null && _r_trailing !== void 0 ? _r_trailing : !0, l = r.maxWait !== void 0 ? Math.max(r.maxWait, a) : void 0;
    let o, d = 0, s = -1, f, i;
    const y = (t)=>(d = t, o && (f = e(...o)), o = void 0, f), T = (t)=>{
        const u = t - s, m = t - d;
        return s < 0 || u >= n || u < 0 || l !== void 0 && m >= l;
    }, I = (t)=>{
        const u = t - s, m = t - d, h = n - u;
        return l !== void 0 ? Math.min(h, l - m) : h;
    }, k = (t)=>(i = void 0, g && o ? y(t) : (o = void 0, f)), v = ()=>{
        const t = Date.now();
        if (T(t)) return k(t);
        i = setTimeout(v, I(t));
    }, W = (t)=>(d = t, i = setTimeout(v, a), c ? y(t) : f), A = function() {
        for(var _len = arguments.length, t = new Array(_len), _key = 0; _key < _len; _key++){
            t[_key] = arguments[_key];
        }
        const u = Date.now(), m = T(u);
        if (o = t, s = u, m) {
            if (i === void 0) return W(s);
            if (l !== void 0) return i = setTimeout(v, a), y(s);
        }
        return i === void 0 && (i = setTimeout(v, a)), f;
    };
    return A.cancel = ()=>{
        i !== void 0 && (clearTimeout(i), i = void 0), d = 0, s = -1, o = void 0;
    }, A.flush = ()=>i === void 0 ? f : k(Date.now()), A;
}, D = (e)=>e === null ? !0 : !(typeof e == "object" || typeof e == "function"), x = (e, n)=>{
    if (e === n) return !0;
    if (D(e) || D(n) || typeof e != typeof n || typeof e == "function") return !1;
    if (Array.isArray(e) || Array.isArray(n)) return Array.isArray(e) && Array.isArray(n) ? e.length === n.length && e.every((c, g)=>x(c, n[g])) : !1;
    if (e instanceof Date || n instanceof Date) return e instanceof Date && n instanceof Date ? e.getTime() === n.getTime() : !1;
    const r = Object.keys(e), a = Object.keys(n);
    return r.length === a.length ? r.every((c)=>x(e[c], n[c])) : !1;
};
export { p as debounce, x as isEqual };
